import React, { Dispatch, SetStateAction, useContext, useState } from 'react';
import ChipsDropDown from '../components/ChipsDropDown';
import { ProductsContext } from '../../ProductsContext';
import { BigDownArrowIcon } from 'assests/GmsIcons';
import CategoryDropDown from '../components/CategoryDropDown';
import ConfirmDialog from 'Pages/GMS/ISR/Components/ConfirmDialog';


type TSelectTarget = {
  selectedProducts: TOption[],
  setSelectedProducts: Dispatch<SetStateAction<TOption[]>>
  payload: TRecategorizePayload
  setPayload: Dispatch<SetStateAction<TRecategorizePayload>>
}

const SelectTarget = ({ selectedProducts, setSelectedProducts, payload, setPayload }: TSelectTarget) => {
  const prodContext = useContext(ProductsContext)
  const handleCategorySelect = (id: string) => {
    const catObjArr = prodContext?.categoryData?.flatMap(x => x?.category || [])?.find(y => y?.id === id)
    setPayload((prev: any) => {
      const newState = {
        ...prev,
        target_category: id,
        target_category_name: catObjArr ? catObjArr?.name : null
      }
      return newState
    })
  }

  const [showComfirmDialog, setShowComfirmDialog] = useState(false)
  const [selectedId, setSelectedId] = useState<string | null>(null)

  const handleConfirmSelect = (e: React.ChangeEvent<HTMLSelectElement>) => {
    e.persist()
    setSelectedId(e?.target?.value)
    if (payload?.target_category) {
      setShowComfirmDialog(true)
    }
    else {
      handleCategorySelect(e?.target?.value)
    }
  }

  return (
    <div className='tw-justify-center tw-items-center'>
      <div className="tw-text-[#091e42] tw-mb-2 tw-text-sm tw-font-medium tw-justify-center tw-items-center">Products to be recategorized</div>
      <div className='tw-w-[400px]'>
      <ChipsDropDown
        header='Products Selected'
          options={selectedProducts}
          setOptions={setSelectedProducts}
          remove={true}
      />
      </div>
      <div>
        <div className="tw-text-[#091e42] tw-mt-6 tw-mb-2 tw-text-sm tw-font-medium tw-justify-center tw-items-center">(From) Source</div>
        <div className={` tw-w-full tw-text-[#969fae] tw-text-sm tw-h-9 tw-px-2.5 tw-py-2  tw-rounded tw-border tw-border-[#d1d1d6] tw-bg-[#f4f5f7]`}>
          {prodContext?.selected_Category?.name}
      </div>
      </div>
      <div className='tw-mt-2'>
        <BigDownArrowIcon />
      </div>
      <div>
        <div className="tw-text-[#091e42] tw-mt-2 tw-mb-2 tw-text-sm tw-font-medium tw-justify-center tw-items-center">(To) Target</div>
        <CategoryDropDown value={payload?.target_category} handleSelect={handleConfirmSelect} />
      </div>
      {showComfirmDialog ?
        <ConfirmDialog id='target-category-change' title={'Change target category?'}
          message={'By changing target you will loose the data set in step 2 and step 3, Do you still want to continue?'}
          onClose={() => {
            setShowComfirmDialog(false);
          }}
          onConfirm={() => {
            if (selectedId) {
              handleCategorySelect(selectedId)
              setShowComfirmDialog(false);
            }
          }} />
        : null}
    </div>
  )
}

export default SelectTarget;